import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VContent,[_c(VRow,[_c(VCol,{attrs:{"cols":"8","lg":"8","xl":"8"}},[_c(VCard,{staticClass:"section-card pa-5",attrs:{"outlined":""}},[_c('NewsStories',{attrs:{"top-news":_vm.news,"sentiment-analysis":_vm.sentiments}})],1)],1),_c(VCol,{attrs:{"cols":"4","lg":"4","xl":"4"}},[_c(VCard,{staticClass:"section-card pa-5",attrs:{"outlined":""}},[_c('SocialFeed',{attrs:{"tweets":_vm.tweets}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }